export enum NETWORK_IDS {
	ETH = 1,
	BSC = 56,
	MATIC = 137,
	XDAI = 100,
	ARB = 42161
}
